import { Injectable } from '@angular/core';
import { HTTPService } from 'src/app/services/http.service';
import { FuncaoStudio } from './formula-catalog.types';
import EXAMPLES from './formula-examples.json';

@Injectable({ providedIn: 'root' })
export class FormulaCatalogService {
  private cache: FuncaoStudio[] | null = null;

  constructor(private http: HTTPService) {}

  load(): Promise<FuncaoStudio[]> {
    if (this.cache) return Promise.resolve(this.cache);
    const ex: any = EXAMPLES;
    return new Promise((res, rej) => {
      this.http.post({}, 'FormulaServices/expressions', true, true, false).subscribe({
        next: (x: any) => {
          this.cache = ((x['resultado'] || []) as FuncaoStudio[])
            .map((f) => {
              const e = ex[f.name];
              return e
                ? { ...f, exemplo: e.exemplo, variaveis: e.variaveis, runnable: e.runnable, validado: e.validado, resultado: e.resultado, retorna: e.retorna, combina: e.combina }
                : f;
            })
            .sort((a, b) => a.name.toUpperCase().localeCompare(b.name.toUpperCase()));
          res(this.cache!);
        },
        error: rej,
      });
    });
  }
}
